






















import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { CreateUserInfo} from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VTable, TableHander } from '@/components/table'
import { VImageUpload } from '@/components/upload'
import { TxLocal } from '@/utils/local/TxLocal'
import constant from '@/utils/constant'

@Component({
  components: {
    VTable,
    VImageUpload,
  },
})
export default class CreateNewUserDialog extends Vue {

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.show = false
  }
  private data: any = {
    mobilePhone: undefined,
    nickname: undefined,
    inviteCode: undefined,
    password: undefined,
  }
  private show = false
  private isEdit = false
  private memberList: Array<any> = []



  public async open() {
    this.show = true
  }

  private requiredRule = { required: true, message: '不能为空', trigger: 'blur' }
  private rules = {
    mobilePhone: [this.requiredRule],
    password: [this.requiredRule],
  }


  public async save() {

    const form = this.$refs.form as ElForm
    form.validate(async (valid: boolean) => {
      if (valid) {
        const result = await CreateUserInfo(this.data)
        if(result){
          this.$message.success("创建成功")
          this.close()
        }

      } else {
        this.$message.error("表单存在错误，不能保存")
        return false
      }
    })
  }
}
